import { module } from 'modujs';
import { html } from '../utils/environment';
import LocomotiveScroll from 'locomotive-scroll';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        setTimeout(() => {
            this.scroll = new LocomotiveScroll({
                el: this.el,
                smooth: true,
            });

            this.scroll.on('call', (func,way,obj,id) => {
                // Using modularJS
                this.call(func[0],{way,obj},func[1],func[2]);
            });

            this.scroll.on('scroll', (args) => {
                // console.log(args.scroll);
            })
        }, 200)
    }

    logoLight(e) {
        if(e.way === 'enter') {
            html.classList.add('has-logo-light')
        }

        if(e.way === 'exit') {
            html.classList.remove('has-logo-light')
        }
    }

    buyNow(e) {
        if(e.way === 'enter') {
            html.classList.add('has-buy-now')
        }

        if(e.way === 'exit') {
            html.classList.remove('has-buy-now')
        }
    }


    toggleLazy(args) {
        let src = this.getData('lazy', args.obj.el)
        if(src.length) {
            if(args.obj.el.tagName == "IMG") {
                args.obj.el.src = src
            } else {
                args.obj.el.style.backgroundImage = `url(${src})`
            }
            this.setData('lazy', '', args.obj.el)
        }
    }

    scrollTo(param) {
        if (this.scroll && this.scroll.scrollTo) {
            this.scroll.scrollTo(param[0], {offset: param[1]})
        }
    }

    update() {
        this.scroll.update();
    }

    destroy() {
        html.classList.remove('has-logo-light')
        this.scroll.destroy();
    }
}
